import { useContext } from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import logo from "../../logo copy/LOGO TIQA PNG STANDRAD WHITE.png";
import { LanguageContext } from "../../../context/LanguageContext";

const MotionLink = motion(NavLink);

export default function Footer() {
  const { t, isRTL } = useContext(LanguageContext);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.1 * i, duration: 0.6, ease: "easeOut" },
    }),
  };

  const linkClass = "hover:text-white transition text-gray-400";

  const productLinks = t("footer.product.links", { returnObjects: true }) || [];
  const companyLinks = t("footer.company.links", { returnObjects: true }) || [];
  const legalLinks = t("footer.legal.links", { returnObjects: true }) || [];

  return (
    <footer dir={isRTL ? "rtl" : "ltr"} className="bg-black text-gray-300">
      <div className="mx-auto max-w-7xl px-6 py-20">

        {/* Top grid */}
        <motion.div
          className="grid grid-cols-1 gap-12 md:grid-cols-4"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Brand */}
          <motion.div variants={fadeUp} custom={1}>
            <img src={logo} alt="Teqa Connect logo" className="w-32" />
            <p className="mt-4 max-w-xs text-sm text-gray-400">
              {t("footer.brand.slogan")}
            </p>

            <div className="mt-6 flex space-x-4 text-sm">
              <a href="https://www.instagram.com/teqaconnect" target="_blank" className={linkClass}>Instagram</a>
              <a href="https://www.facebook.com/share/17QUTjY5nJ/?mibextid=wwXIfr" target="_blank" className={linkClass}>Facebook</a>
              <a href="https://www.linkedin.com/company/teqaconnect/" target="_blank" className={linkClass}>LinkedIn</a>
              <a href="https://x.com/teqaconnect" target="_blank" className={linkClass}>X</a>
            </div>
          </motion.div>

          {/* Product */}
          <motion.div variants={fadeUp} custom={2}>
            <h4 className="mb-4 text-sm font-semibold uppercase text-white">
              {t("footer.product.title")}
            </h4>
            <ul className="space-y-3 text-sm">
              {productLinks.map((link, i) => (
                <li key={i}>
                  <MotionLink to={link.path} className={linkClass}>
                    {link.label}
                  </MotionLink>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Company */}
          <motion.div variants={fadeUp} custom={3}>
            <h4 className="mb-4 text-sm font-semibold uppercase text-white">
              {t("footer.company.title")}
            </h4>
            <ul className="space-y-3 text-sm">
              {companyLinks.map((link, i) => (
                <li key={i}>
                  <MotionLink to={link.path} className={linkClass}>
                    {link.label}
                  </MotionLink>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Legal */}
          <motion.div variants={fadeUp} custom={4}>
            <h4 className="mb-4 text-sm font-semibold uppercase text-white">
              {t("footer.legal.title")}
            </h4>
            <ul className="space-y-3 text-sm">
              {legalLinks.map((link, i) => (
                <li key={i}>
                  <MotionLink to={link.path} className={linkClass}>
                    {link.label}
                  </MotionLink>
                </li>
              ))}
            </ul>
          </motion.div>
        </motion.div>

        {/* Divider */}
        <div className="my-12 border-t border-gray-800" />

        {/* Bottom */}
        <motion.div
          className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div>
            <h4 className="mb-4 font-semibold text-white">
              {t("footer.contact.title")}
            </h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>📧 {t("footer.contact.email")}</li>
              <li>💼 {t("footer.contact.sales")}</li>
              <li>🆘 {t("footer.contact.support")}</li>
            </ul>
          </div>

          <p className="text-sm text-gray-500">
            {t("footer.copyright")}
          </p>
        </motion.div>

      </div>
    </footer>
  );
}
